// extracted by mini-css-extract-plugin
module.exports = {"landing_page_R2PTSB":"R2PTSB_landing_page_R2PTSB__f5UBk"};